module.exports = __webpack_public_path__ + "311c71d1a94260f5490f4a9d61939521.svg";